import React, {useEffect, useState} from "react";
import './homeScreenStyles.css';
import HomeNavBar from '../HomeNavBar';
import HomePageBanner from "./homePageBanner";
import SearchList from "../SearchResults/SearchList";
import axios from "axios";

// Home page.
const  HomePage =  () => {

    //check if a session is going on
    const[user, setUser] = useState([])

    //using axios for easy fetching
    useEffect( () => {
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {
            if(response.data){
                setUser(response.data)
            }
        });
    }, []);

    const printUser = () => {
        //console.log("Print is called")
        if(user.name)
            return user.name;
        else
            return "Login";
    }

    //console.log(printUser());

    return(
        <div className={"row"}>
            <HomeNavBar user ={user.name}/>
            <HomePageBanner/>
            {
                printUser() !== "Login" &&
                <div className={"container"} style={{marginTop:"120px"}}>
                    <h2>Popular Restaurants</h2>
                    <SearchList zip = {user.zipCode}/>
                </div>
            }
            {
                printUser() === "Login" && <div className={"container"} style={{marginTop:"120px"}}>
                    <h2>Popular Restaurants</h2>
                    <SearchList zip ={"02120"}/>
                </div>
            }

        </div>
    );
}

export default HomePage;